module.exports = __webpack_public_path__ + "img/chikuho.1fd4b417.png";